import React, { useEffect } from "react";
import { Badge, Avatar, Typography } from "@mui/material";
import classes from "./chat.module.css";
import {
  checkOnline,
  generateColor,
  stringAvatar,
} from "../../../utilities/commonFunctions";
import { decodeFileName } from "../../../utilities/fileName";

const getLastMessagePreview = (member) => {
  const lm = member?.last_message;
  if (lm) {
    if (lm.message_type === "image") return "📷 Image";
    if (lm.message_type === "audio") return "🎤 Audio Note";
    if (lm.message_type === "file") return `📄 ${decodeFileName(lm.file_name) || "File"}`;
    if (lm.message) {
      return lm.message.length > 100 ? lm.message.substring(0, 100) + "..." : lm.message;
    }
  }
  const text = member?.lastMessage || "";
  return text.length > 100 ? text.substring(0, 100) + "..." : text;
};

const ChatContactCard = ({ index, OpenChat, member, ChatMembers }) => {
  useEffect(() => {
    console.log(member, "Check ProfilePic");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div key={index} style={{ position: "relative" }}>
      <div
        className={classes.chat_IndividualContactsMainDiv}
        onClick={() => OpenChat(member)}
      >
        <div className={classes.chat_IndividualContactsSubDiv}>
          {member.conversation_type === "group" ? (
            <div>
              <Avatar
                {...stringAvatar(`${member?.name?.trim()}`)}
                sx={{
                  backgroundImage:
                    "linear-gradient(to bottom, #1273B8, #BE5060)",
                  bgcolor: member?.departmentInfo?.colour
                    ? member.departmentInfo.colour
                    : `${generateColor(`${member?.receiverDetails[0]?.name}`)}`,
                  textTransform: "uppercase",
                }}
              />
            </div>
          ) : (
            <Badge
              color={
                checkOnline(member?.receiverDetails[0]?._id) === "checkin"
                  ? "success"
                  : "error"
              }
              badgeContent=""
              variant="dot"
              overlap="circular"
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              className={classes.LocationOnlineBadge}
            >
              {member?.receiverDetails[0]?.profile_pic ? (
                <Avatar
                  alt={member?.receiverDetails[0]?.name}
                  src={`${process.env.REACT_APP_IMAGE_URL}/${member?.receiverDetails[0]?.profile_pic?.destination}${member?.receiverDetails[0]?.profile_pic?.filename}`}
                />
              ) : (
                <Avatar
                  {...stringAvatar(`${member?.name.trim()}`)}
                  sx={{
                    bgcolor: member?.departmentInfo?.colour
                      ? member.departmentInfo.colour
                      : `${generateColor(
                          `${member?.receiverDetails[0]?.name}`,
                        )}`,
                    textTransform: "uppercase",
                  }}
                />
              )}
            </Badge>
          )}
          <div>
            <Typography className={classes.chat_ContactPersonName}>
              {/* {member?.name.split("-")[0]} */}
              {member?.conversation_type === "group"
                ? member?.name
                : member?.receiverDetails[0]?.name || ""}
            </Typography>
            <Typography className={classes.Chat_lastMessage}>
              {getLastMessagePreview(member)}
            </Typography>
          </div>
        </div>

        <div>
          {/* <Typography className={classes.Chat_lastMessage}>
            Yesterday
          </Typography> */}
          {member.unseenCount > 0 && (
            <Typography className={classes.messageCount}>
              {member.unseenCount}
            </Typography>
          )}
        </div>
      </div>
      {index + 1 !== ChatMembers?.length ? (
        <hr className={classes.Chart_contactUnderLine} />
      ) : null}
    </div>
  );
};

export default ChatContactCard;
